import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface HeroSectionProps {
  goToSlide?: (index: number) => void;
}
export function HeroSection({
  goToSlide
}: HeroSectionProps) {
  return <section className="h-full flex items-center justify-center px-4 sm:px-6 lg:px-8 bg-white overflow-y-auto lg:overflow-hidden" data-id="element-124">
      <div className="max-w-4xl mx-auto text-center" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="space-y-8" data-id="element-126">
          <div className="inline-block" data-id="element-127">
            <span className="inline-flex items-center px-4 py-1.5 rounded-full text-[10px] font-bold bg-[#80BC41]/10 text-[#80BC41] tracking-widest uppercase border border-[#80BC41]/20" data-id="element-128">
              Prepared by Agency Epic for Toyota Adria
            </span>
          </div>

          <div className="space-y-5" data-id="element-129">
            <h1 className="text-4xl md:text-7xl font-bold text-[#1a1a1a] tracking-tight leading-[1.1] font-heading bg-[#ffffff]" data-id="element-130">
              Improving Toyota Special Offers Landing
            </h1>
            <p className="text-lg md:text-2xl text-gray-500 font-medium max-w-2xl mx-auto" data-id="element-131">
              A better approach to UX, flexibility and conversion
            </p>
            <p className="text-sm md:text-base text-gray-400 max-w-xl mx-auto" data-id="element-132">
              Modern campaign landing pages built for results
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-6" data-id="element-133">
            <button onClick={() => goToSlide && goToSlide(1)} className="w-full sm:w-auto px-8 py-4 border border-gray-200 rounded-full font-medium hover:border-gray-300 hover:bg-gray-50 transition-all flex items-center justify-center text-[#FFFFFF] bg-[#1A1A1A]" data-id="element-134">
              From challenge to solution
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}